<div *ngIf="heeftLoondienst()">
    <form (change)=saveForm() [formGroup]="reisaftrekOv">
        <div *ngIf="reisaftrekOpenbaarVervoer.length > 0">
            <div formArrayName="reisaftrekOpenbaarVervoer">
                <div *ngFor="let reisOv of reisaftrekOpenbaarVervoer.controls; let i = index;"
                     [formGroupName]="i" class="row">
                    <div class="col-auto row">
                        <snelstart-ui-text-form-control (change)="saveForm()"
                                                        [label]="i === 0 ? 'Arbeidsplaats' : ''"
                                                        class="custom-input-250 col-auto"
                                                        formControlName="omschrijving"
                                                        id="omschrijving"
                        >
                        </snelstart-ui-text-form-control>
                        <snelstart-ui-number-form-control (change)="saveForm()"
                                                          [decimals]="0"
                                                          [label]="i === 0 ? 'Afstand enkele reis' : ''"
                                                          align="right"
                                                          class="custom-input-150 col-auto"
                                                          formControlName="afstandEnkeleReis"
                                                          id="afstandEnkeleReis"
                                                          prefix="km"
                        >
                        </snelstart-ui-number-form-control>
                        <div class="col-auto row" formGroupName="periodeVanReizen">
                            <snelstart-ui-date-form-control (change)="saveForm()"
                                                            [label]="i === 0 ? 'Begindatum' : ''"
                                                            class="col-auto custom-input-150"
                                                            formControlName="begindatum"
                                                            id="begindatum"
                            >
                            </snelstart-ui-date-form-control>
                            <snelstart-ui-date-form-control (change)="saveForm()"
                                                            [label]="i === 0 ? 'Einddatum' : ''"
                                                            class="col-auto custom-input-150"
                                                            formControlName="einddatum"
                                                            id="einddatum"
                            >
                            </snelstart-ui-date-form-control>
                        </div>
                        <div class="col-auto">
                            <snelstart-ui-select-form-control (change)="saveForm()"
                                                              [label]="i === 0 ? 'Reisdagen per week' : ''"
                                                              [options]="optionsAantalDagen"
                                                              class="custom-input-150"
                                                              formControlName="aantalDagenPerWeek"
                            >
                            </snelstart-ui-select-form-control>
                        </div>
                        <div class="col-auto">
                            <snelstart-ui-number-form-control (change)="saveForm()"
                                                              [decimals]="0"
                                                              [label]="i === 0 ? 'Vergoeding werkg.' : ''"
                                                              align="right"
                                                              class="custom-input-150"
                                                              formControlName="vergoedingWerkgever"
                                                              id="vergoedingWerkgever"
                                                              prefix="€"
                            >
                            </snelstart-ui-number-form-control>
                        </div>
                        <div class="col-auto">
                            <snelstart-ui-button (click)="verwijderRijReisaftrekOv(i)"
                                                 [class]="i === 0 ? 'firstrowbutton' : ''"
                                                 class="delete"
                                                 icon="trash"
                                                 iconType="light"
                                                 id="buttonDelete"
                                                 size="medium"
                                                 type="secondary"
                            >
                            </snelstart-ui-button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
</form>


<div *ngIf="reisaftrekOpenbaarVervoer.length === 0">
    <snelstart-ui-button (click)="addRijReisaftrekOv()" class="snelstart-ui-button" icon="plus"
                         type="link">Reiskosten invullen
    </snelstart-ui-button>
</div>

<div *ngIf="reisaftrekOpenbaarVervoer.length > 0">
    <snelstart-ui-button (click)="addRijReisaftrekOv()" class="snelstart-ui-button" icon="plus"
                         type="link">Reiskosten toevoegen
    </snelstart-ui-button>
</div>

</div>

<div *ngIf="!heeftLoondienst()" style="width: 50%">
    <snelstart-ui-alert type="info">
        <div *ngIf="!partnerBoolean">
            Er zijn geen inkomsten uit loondienst voor {{ this.dataService.naamAangever }} ingevuld.
        </div>

        <div *ngIf="partnerBoolean">
            Er zijn geen inkomsten uit loondienst voor {{ this.dataService.naamPartner }} ingevuld.
        </div>
    </snelstart-ui-alert>
</div>
